// import UserCard from '../../../../../components/mazraeKit/cards/userCard';
import MainFooter from '../../../../../components/mazraeKit/footers/footerMain';
import CustomHeader from '../../../../../components/mazraeKit/headers/homeHeader';

const MyStoreCommentsListing = () => {
  return (
    <div className="flex flex-col">
      <CustomHeader title="دیدگاه مشتریان" preIcon="icon-nameArrow---Right" />
      <div className="flex flex-col h-full">
        {/* {commentsList?.results.map((item, index) => (
          <UserCard
            rate={3.5}
            key={index}
            cardWrapperClassName="w-full"
            timeDate={'۲۳‌ مهر ۱۴۰۲'}
            description={item.text}
            name={item.store.title}
          />
        ))} */}
      </div>
      <MainFooter />
    </div>
  );
};

export default MyStoreCommentsListing;
